import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { CallOverlay as ReactCallOverlay, } from '../../../../common/components/call-overlay';
export const CallOverlay = forwardRef(({ hasVideo, hasAudio }, ref) => {
    const [_hasVideo, setHasVideo] = useState(hasVideo);
    const [_hasAudio, setHasAudio] = useState(hasAudio);
    useImperativeHandle(ref, () => ({
        onChangeVideo: (hasVideo) => setHasVideo(hasVideo),
        onChangeAudio: (hasAudio) => setHasAudio(hasAudio),
    }));
    return <ReactCallOverlay hasAudio={_hasAudio} hasVideo={_hasVideo}/>;
});
